const SECONDS_IN_A_MINUTE = 60;

/**
 * Calculate seconds for currently running match (`started` = true).
 *
 * @param {boolean} reverse
 * @param {number} gameTime
 * @param {Date} timestamp
 * @param {Date} now
 * @return {number} seconds
 */
export const calculateMatchDurationSeconds = ({ reverse, gameTime, timestamp }, now) => {
  const diff = Math.round((now.getTime() - timestamp.getTime()) / 1000);
  return !reverse ? (gameTime + diff) : (gameTime - diff);
};

/**
 * Format match duration seconds to 'mm:ss' format.
 *
 * @param {number} seconds
 * @return {string}
 */
export const formatMatchDurationTime = (seconds) => {
  const mm = (`${Math.floor(seconds / SECONDS_IN_A_MINUTE)}`).padStart(2, '0');
  const ss = (`${seconds % SECONDS_IN_A_MINUTE}`).padStart(2, '0');
  return `${mm}:${ss}`;
};

/**
 * Convert seconds to minutes, rounding up.
 *
 * @param {number} seconds
 * @return {number} minutes
 */
export const convertSecondsToMinutes = (seconds) => Math.ceil(seconds / SECONDS_IN_A_MINUTE);
